import React from 'react'
import Layout from '../../Layout'
import VehicleListContainer from '../../../../Components/VehicleContainer/VehicleListContainer/VehicleListContainer'

const VehicleList = () => {
  return (
    <Layout>
        <VehicleListContainer/>
    </Layout>
  )
}

export default VehicleList